<!-- weChatShare 微信分享设置 -->
<template>
  <div class="weChatShare">
    <el-form ref="ruleForm" :model="ruleForm" label-width="110px">
      <div class="part">
        <div class="left-part">
          <img :src="weChatShareImg" alt="" />
        </div>
        <div class="right-part">
          <div class="flex-content">
            <div class="left">
              <el-form-item label="微信分享设置：" class="mag-cover-box" size="zdy4" prop="weChatShareCoverId">
                <div class="mag-cover upload-img">
                  <img class="fl" :src="weChatShareCoverSrc" alt />
                  <el-upload
                    class="upload-demo"
                    :action="UploadPictureStream"
                    name="file"
                    :show-file-list="false"
                    accept=".png, .jpg, .jpeg"
                    :auto-upload="true"
                    :on-success="handleWeChatShareCoverSuccess"
                  >
                    <el-button class="upload-btn" size="small" type="primary">上传图片</el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item label="分享标题：" size="zdy6" prop="weChatShareTitle" class="common-style">
                <el-input v-model="ruleForm.weChatShareTitle" type="text" />
              </el-form-item>
              <el-form-item label="分享内容：" size="zdy1" prop="weChatShareContent" class="common-style">
                <el-input autosize v-model="ruleForm.weChatShareContent" type="textarea" />
              </el-form-item>
            </div>
          </div>
          <div class="el-upload__tip">格式支持：jpg、png、jpeg<span class="betterSize">尺寸推荐：156*231</span></div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { GetPictureStream, UploadPictureStream } from '@/api/configManage'

export default {
  name: 'weChatShare',
  data() {
    return {
      morImg: require('@/assets/img/img_default.png'),
      weChatShareImg: require('@/assets/img/weChatShare.jpg'),
      GetPictureStream: GetPictureStream,
      UploadPictureStream: UploadPictureStream,
      weChatShareCover: ''
    }
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  watch: {
    magId() {
      this.$nextTick(() => {
        this.$refs.ruleForm.resetFields()
      })
    }
  },
  computed: {
    weChatShareCoverSrc() {
      return this.weChatShareCover ? this.weChatShareCover : this.ruleForm.weChatShareCoverId ? `${this.GetPictureStream}?pictureId=${this.ruleForm.weChatShareCoverId}` : this.morImg
    }
  },
  created() {},
  methods: {
    handleWeChatShareCoverSuccess(res, file) {
      const { data } = res
      const { ID } = data
      this.weChatShareCover = URL.createObjectURL(file.raw)
      this.$set(this.ruleForm, 'weChatShareCoverId', ID)
    }
  }
}
</script>
<style lang="scss">
.weChatShare {
  .el-form-item--zdy1 .el-form-item__label {
    line-height: 47px;
  }
}
</style>
<style lang="scss" scoped>
.weChatShare {
  .left-part {
    height: 318px;
    img {
      height: 100%;
      object-fit: contain;
    }
  }
  .mag-cover {
    width: 156px;
    height: 231px;
  }
}
</style>
